import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';

import { MetricConversionPipe, RnplCommonModule } from 'common/src/modules/rnpl-common';
import { InsuranceCostFormComponent } from './insurance-cost-form.component';
import { UIComponentsModule } from 'common/src/modules';
import { NgxCurrencyModule } from 'ngx-currency-custom';
import { VatRatesDropdownModule } from '../vat-rates-dropdown/vat-rates-dropdown.module';

@NgModule({
  declarations: [
    InsuranceCostFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    UIComponentsModule,
    NgxMaskModule,
    NgxCurrencyModule,
    RnplCommonModule,
    TranslateModule,
    VatRatesDropdownModule
  ],
  exports: [InsuranceCostFormComponent],
  entryComponents: [InsuranceCostFormComponent],
  providers: [MetricConversionPipe]
})
export class InsuranceCostFormModule { }
